import React from 'react'
import { FormGroup } from "reactstrap"
import { Select } from 'antd'

const FilterSelect = ({
    mode,
    type,
    field = '',
    label = "",
    value = [],
    options = [],
    onChangeFilter,
    placeholder = '',
    filtersCache = {},
    onChangeFilterCache
}) => {

    const _handleChange = (value) => {
        if (type === 'filter') {
            onChangeFilterCache({ [field]: value })
            if (value.length === 0) onChangeFilter({ [field]: value })
        } else {
            onChangeFilter({ [field]: value })
        }
    }

    const onBlurChangeSelect = () => {
        if (Object.keys(filtersCache).length > 0) {
            const newValue = filtersCache[field] || []
            if (newValue.length > 0) onChangeFilter({ [field]: newValue })
        } else {
            if (value.length > 0) onChangeFilter({ [field]: value })
        }
    }

    const onDeselectChangeSelect = (e) => {
        if (Object.keys(filtersCache).length > 0) {
            const newValue = filtersCache[field] || []
            onChangeFilter({ [field]: newValue.filter(v => v !== e) })
        } else {
            onChangeFilter({ [field]: value.filter(v => v !== e) })
        }
    }

    return (
        <FormGroup className="d-flex flex-column">
            <label className='font-weight-bold mb-1'>{label}</label>
            <Select
                className='skuFilter'
                showSearch
                allowClear
                mode={mode}
                style={{ minWidth: '300px' }}
                placeholder={placeholder}
                value={type === 'filter' ? filtersCache[field] : value}
                options={(field === 'skus' && type === "filter") ? options.map(i => ({ label: i.label, value: i.label })) : options}
                optionFilterProp="children"
                filterOption={(input, option) => (option.label.toLowerCase() || '').includes(input.toLowerCase())}
                onChange={_handleChange}
                onBlur={onBlurChangeSelect}
                onDeselect={value => onDeselectChangeSelect(value)}
                tokenSeparators={[',', ' ']}
                onPaste={(e) => {
                    const pasted = e.clipboardData.getData('text')
                    if (pasted) {
                        e.preventDefault()
                        const values = pasted
                            .split(/[\n, ]+/)
                            .map(v => v.trim())
                            .filter(Boolean)
                        const valuesSelect = type === "create" ? options.filter(i => values.includes(i.label)).map(o => o.value) : values
                        const newValues = [...new Set([...(value || []), ...valuesSelect])]
                        _handleChange(newValues)
                    }
                }}
            />
        </FormGroup>
    )
}

export default FilterSelect